export default "/rts_icon.3c609146-75703b.svg?svgr";